import {Component, ViewChild} from "@angular/core";
import {IUserReservationService} from "../../../../../domain/leasing/IUserReservationService";
import {UserReservations} from "../../../../../../../../server/src/base/entities/leasing/calendar/UserReservations";
import {UserReservation} from "../../../../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {IVanService} from "../../../../../domain/leasing/IVanService";
import {AdminUserReservationComponent} from "./adminUserReservation/adminUserReservation";
import {UserReservationAdminEditComponent} from "../../../garage/leasing/presentation/userReservation/userReservationAdminEdit";

@Component({
    selector: 'admin-reservations-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class AdminReservationsPresentationComponent {

    @ViewChild('userReservationDialog') public userReservationDialog:UserReservationAdminEditComponent;

    private userReservationService:IUserReservationService;
    private vanService:IVanService;
    public userReservations:UserReservations;
    public filteredUserReservations:UserReservations;
    public name:string;

    constructor(userReservationService: IUserReservationService, vanService:IVanService) {
        this.userReservationService = userReservationService;
        this.vanService = vanService;
        this.filteredUserReservations = new UserReservations();
        this.name = "";
    }

    ngOnInit(){
        this.userReservationService.GetAll().then(userReservations => {
            this.userReservations = userReservations;
            this.FilterReservations();
        })
    }

    public onNameChanged(name:string){
        this.name = name;
        this.FilterReservations();
    }

    public onValidated(component:AdminUserReservationComponent){
        this.userReservationService.Validate(component.userReservation).then(() => {
            component.Validate();
        });
    }

    public onRemoved(userReservation:UserReservation){
        this.userReservationService.Cancel(userReservation).then(() => {
            this.userReservations.Remove(userReservation);
            this.FilterReservations();
        })
    }

    public onUpdated(userReservation:UserReservation){
        this.userReservationService.Get(userReservation.id).then(userReservationWithReservations => {
            this.vanService.Get(userReservation.vanId).then(van => {
                this.vanService.Vans(van.leasing.type).then(vans => {
                    if(vans.Value().length > 0){
                        this.userReservationDialog.Open(vans, userReservationWithReservations);
                    }
                });
            })
        });
    }

    public onDetailsRequired(component:AdminUserReservationComponent){
        this.userReservationService.Get(component.userReservation.id).then(userReservationWithReservations => {
            this.vanService.Get(component.userReservation.vanId).then(van => {
                component.userReservation = userReservationWithReservations;
                component.van = van;
                component.DetailsSet();
            });
        });
    }

    private FilterReservations(){
        let validReservations:Array<UserReservation> = [];
        for(let userReservation of this.userReservations.Value()){
            if(userReservation.lastname.toLowerCase().includes(this.name.toLowerCase())){
                validReservations.push(userReservation);
            }
        }

        validReservations.sort((reservation1, reservation2) => {
            return (reservation1.validated === reservation2.validated) ?
                0 : reservation1.validated? 1 : -1;
        });
        this.filteredUserReservations = new UserReservations(validReservations);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/reservations/presentation/presentation.ts